import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router";
import ProfileTabsNav from "../../components/ProfileTabsNav";
import { ContentStyle } from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import { PatientProfileInsuranceInfo } from "../../Apis/AuthApiServices";
import useFetch from "../../CustomHooks/useFetch";
import { useEffect, useState } from "react";

export default function InsuranceInformation() {
  const navigate = useNavigate();
  const patientId = sessionStorage.getItem("patientId");
  const [Info, setInfo] = useState<any>([]);
  const Params = {
    patientId: patientId,
    pageNumber: "0",
  };
  const { data, loading }: any = useFetch(
    Params,
    PatientProfileInsuranceInfo,
    []
  );

  useEffect(() => {
    if (data) {
      setInfo(data);
    }
  }, [data]);

  return (
    <>
      <ProfileTabsNav />
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Insurance Information
          <HelpGuideTooltip
            content={
              <>
                <Typography component="div" variant="body1">
                  If the patient is connected to any payers, their insurance
                  information will be displayed here.
                </Typography>
              </>
            }
          />
        </Typography>
        {loading ? (
          <Box
            style={{
              width: "100%",
              height: 200,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress color="primary" />
          </Box>
        ) : (
          <Grid
            container
            item
            xs={12}
            alignItems="center"
            justifyContent="center"
            bgcolor={"#D9D9D9"}
            padding={"10px"}
            borderRadius={"8px"}
            height={"200px"}
            marginY={3}
          >
            <Grid item xs={12}>
              <Typography variant="body2" component="div" textAlign={"center"}>
                {Info?.digitalRxStatusMessage ?? "No results"}
              </Typography>
            </Grid>
          </Grid>
        )}
        <Grid item xs={12} textAlign="right" className="btns">
          <YSButton
            onClick={() => {
              navigate("/newrxpad");
            }}
            className=""
            children={"Back to NewRx"}
            size={"large"}
            type="submit"
            color="primary"
            variant="outlined"
          />
        </Grid>{" "}
      </ContentStyle>
    </>
  );
}
